module.exports = __webpack_public_path__ + "static/media/banner-img.1ee255ef.png";